/**
 * Returns the set of layer names that should be visible at the given zoom level.
 *
 * @param {number} zoom - Current Google Maps zoom level
 * @param {Record<string, number>} visibilityMap - Layer name → minimum zoom threshold
 * @returns {Set<string>}
 */
function computeVisibleLayers(zoom, visibilityMap) {
  const layerNames = Object.keys(visibilityMap);

  return new Set(
    layerNames.filter((layerName) => zoom >= visibilityMap[layerName])
  );
}

export default computeVisibleLayers;
